import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Voip/CallTestRequest';
const moduleService = "voip-fusion-call-service"
const api = {
    namespaced: true,
    state: {},
    actions: {
    async callTestRequest (context, params) {
      let api = {
        verb: 'post',
        service: moduleService,
        url: baseUrl + '/callTestRequest',
        data: AFD(params.data)
      };

      return new Promise((resolve, reject) => {
        context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
          resolve(r);
        }).catch(e => {
          reject(e);
        })
      })
    },
    async update (context, params) {
      let api = {
        verb: 'post',
        service: moduleService,
        url: baseUrl + '/update/' + params.id,
        data: AFD(params.data)
      };

      return new Promise((resolve, reject) => {
        context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
          resolve(r);
        }).catch(e => {
          reject(e);
        });
      })
    },
    async remove (context, params) {
      let api = {
        verb: 'post',
        service: moduleService,
        url: baseUrl + '/remove/' + params.id
      };

      return new Promise((resolve, reject) => {
        context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
          resolve(r);
        }).catch(e => {
          reject(e);
        });
      })
    },
    async list (context, params) {
      let api = {
        verb: 'get',
        service: moduleService,
        url: baseUrl + '/list',
        data: null
      };

      return new Promise((resolve, reject) => {
        context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
          let data = r.data;
          let list = [];
          for (let i in data) {
            list.push(data[i]);
          }

          resolve(list);
        }).catch(e => {
          reject(e);
        });
      })
    },
    async get (context, params) {
      let api = {
        verb: 'get',
        service: 'API_GATEWAY',
        url: baseUrl + '/get/' + params.id
      };

      return new Promise((resolve, reject) => {
        context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
          resolve(r);
        }).catch(e => {
          reject(e);
        });
      })
    }
  }
};

export default api
